import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ROLE_TYPES, LOCK_TYPES } from 'app/models/unloc.model';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-unloc',
    templateUrl: './unloc.component.html',
    styleUrls: ['./unloc.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class UnlocComponent implements OnInit {

  // Mock data:
  roleTypes = ROLE_TYPES;
  lockTypes = LOCK_TYPES;

  constructor() { }

  ngOnInit(): void {
  }

}
